import { render, staticRenderFns } from "./relValeTransportes.vue?vue&type=template&id=167f2e7b"
import script from "./relValeTransportes.vue?vue&type=script&lang=ts"
export * from "./relValeTransportes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports